// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var msisdn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "msisdn"), null));
  if (msisdn.TAG === /* Ok */0) {
    var crn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "crn"), null));
    if (crn.TAG === /* Ok */0) {
      var $$location = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "location"), null));
      if ($$location.TAG === /* Ok */0) {
        var caller_number = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "caller_number"), null));
        if (caller_number.TAG === /* Ok */0) {
          var order_stage = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_stage"), null));
          if (order_stage.TAG === /* Ok */0) {
            var raised_by = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "raised_by"), null));
            if (raised_by.TAG === /* Ok */0) {
              var crt_id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "crt_id"), null));
              if (crt_id.TAG === /* Ok */0) {
                var callback_language = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "callback_language"), null));
                if (callback_language.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            msisdn: msisdn._0,
                            crn: crn._0,
                            location: $$location._0,
                            caller_number: caller_number._0,
                            order_stage: order_stage._0,
                            raised_by: raised_by._0,
                            crt_id: crt_id._0,
                            callback_language: callback_language._0
                          }
                        };
                }
                var e = callback_language._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".callback_language" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = crt_id._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".crt_id" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = raised_by._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".raised_by" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = order_stage._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".order_stage" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = caller_number._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".caller_number" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = $$location._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".location" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = crn._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".crn" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = msisdn._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".msisdn" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

export {
  t_decode ,
  
}
/* No side effect */
